import { POST } from "../../APiHelper/API"

export const getTeamsFromLeaguesInValidCupsAPI = (leagues_ids, onSuccess, onError) => {
    const data = {
        leagues_ids: leagues_ids,

    }
    POST("/api/v1/seasons_and_cups/teams_from_leagues_in_valid_cups", data, onSuccess, onError)
}